import { render, staticRenderFns } from "./RequestDataCopy.vue?vue&type=template&id=0061e84c&scoped=true"
import script from "./RequestDataCopy.vue?vue&type=script&lang=js"
export * from "./RequestDataCopy.vue?vue&type=script&lang=js"
import style0 from "./RequestDataCopy.vue?vue&type=style&index=0&id=0061e84c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061e84c",
  null
  
)

export default component.exports